import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Receipt, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const GOLD = "#C9A84C";

// Visible on every partner dashboard from day one; locked (gold padlock) until Vinci Admin activates.
export function BillDeskTile() {
  const { api } = useAuth();
  const [acc, setAcc] = useState(null);
  useEffect(() => { api.get("/billdesk/me").then((r) => setAcc(r.data.account)).catch(() => {}); }, [api]);
  const status = acc?.status || "locked";
  const locked = status !== "active";
  const ent = acc?.entitlement;
  const sub = status === "pending" ? "Activation Pending — Your request is under review by Vinci Admin"
    : status === "active" ? (ent?.can_generate ? (ent.source === "free" ? `${ent.free_label} · 110 GST-compliant templates` : "Active · 110 GST-compliant templates") : "Free Invoice Used — Upgrade to Continue")
    : "Vinci BillDesk — Activation Required";
  return (
    <Link to="/billdesk" data-testid="billdesk-tile" data-status={status}
          className="group flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-sm border p-5 mb-6 transition-colors"
          style={{ borderColor: `${GOLD}${locked ? "55" : "99"}`, background: "linear-gradient(135deg, #0f0d08 0%, #0A0A0A 70%)" }}>
      <span className="grid place-items-center w-11 h-11 rounded-full shrink-0 border" style={{ borderColor: GOLD, color: GOLD, boxShadow: `0 0 18px ${GOLD}55` }}>
        {locked ? <Lock size={18} data-testid="billdesk-padlock" /> : <Receipt size={18} />}
      </span>
      <div className="flex-1 min-w-0">
        <div className="font-grotesk text-[8px] uppercase tracking-[0.4em]" style={{ color: GOLD }}>Vinci BillDesk</div>
        <div className="font-serif text-lg text-[#F5F5F0] mt-0.5">GST-compliant billing for Civil Engineering &amp; Construction</div>
        <div className="font-body text-[12px] mt-1" style={{ color: locked ? GOLD : "#C9C3B4" }} data-testid="billdesk-tile-status">{sub}</div>
      </div>
      <span className="inline-flex items-center gap-1 font-grotesk text-[10px] uppercase tracking-[0.2em] group-hover:gap-2 transition-all self-start" style={{ color: GOLD }}>{locked ? "Open" : "Enter desk"} <ArrowRight size={13} /></span>
    </Link>
  );
}
